import { SSRMeasures } from '@confluence/action-measures';
import { StatsigConfigurations } from '@confluence/statsig-client/entry-points/StatsigConfigurations';

// 500 ms timeout for each macro loading task, as this is the value the feature
// was rolled out with. On staging, we use 1000 ms to avoid test flakiness.
const TIMEOUT =
	process.env.CLOUD_ENV === 'staging' ||
	process.env.CLOUD_ENV === 'branch' ||
	process.env.CLOUD_ENV === 'dev'
		? 1000
		: 500;

export const macroPreloadGuard = async (
	name: string,
	task: () => Promise<any>,
): Promise<boolean> => {
	const timeout = StatsigConfigurations.getNumber(
		'confluence_frontend_prealod_macro_timeout',
		TIMEOUT,
	);

	const timeoutPromise = new Promise<boolean>((resolve) =>
		setTimeout(() => {
			if (process.env.NODE_ENV === 'production') {
				// eslint-disable-next-line no-console
				console.error(`SSR macro preload task "${name}" timed out after ${timeout}ms`);
			}
			resolve(false);
		}, timeout),
	);

	const runTask = async () => {
		await SSRMeasures.run(`ssr-app/prepare/preloadQuery/macroPreloadGuard:${name}`, task);
		return true;
	};

	return Promise.race([timeoutPromise, runTask()]);
};
